import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Star, Clock } from 'lucide-react';
const advantages = [{
  icon: <Star size={28} strokeWidth={1.5} data-id="element-28" />,
  title: 'Бездоганний сервіс',
  description: 'Ми передбачаємо ваші бажання ще до того, як ви їх озвучите. Увага до кожної деталі та преміальний підхід.'
}, {
  icon: <ShieldCheck size={28} strokeWidth={1.5} data-id="element-29" />,
  title: 'Надійність',
  description: 'Працюємо тільки з перевіреними підрядниками. Гарантуємо ідеальне виконання в рамках затвердженого бюджету.'
}, {
  icon: <Clock size={28} strokeWidth={1.5} data-id="element-30" />,
  title: 'Ідеальний таймінг',
  description: 'Кожна хвилина вашого заходу спланована з точністю швейцарського годинника. Жодних затримок чи форс-мажорів.'
}];
export function Advantages() {
  return <section className="py-24 bg-background" data-id="element-31">
      <div className="max-w-7xl mx-auto px-6" data-id="element-32">
        <div className="text-center max-w-2xl mx-auto mb-20" data-id="element-33">
          <h2 className="text-3xl md:text-4xl font-semibold mb-6" data-id="element-34">
            Чому обирають нас
          </h2>
          <p className="text-secondary text-lg" data-id="element-35">
            Ми не просто організовуємо події, ми створюємо еталонний досвід, де
            кожна деталь має значення.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-36">
          {advantages.map((adv, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="group bg-surface p-8 rounded-3xl border border-border hover:border-primary/50 transition-colors duration-300" data-id="element-37">
              <div className="w-14 h-14 bg-background rounded-2xl flex items-center justify-center text-primary mb-6 border border-border group-hover:scale-110 transition-transform duration-500" data-id="element-38">
                {adv.icon}
              </div>
              <h3 className="text-xl font-medium mb-3" data-id="element-39">{adv.title}</h3>
              <p className="text-secondary leading-relaxed text-sm" data-id="element-40">
                {adv.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}